import { CommonModule } from "@angular/common";
import { Component, computed, inject, OnInit } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { ChatPageModule } from "chat-library";
import { IonContent, IonHeader, Platform } from "@ionic/angular/standalone";
import { NavbarComponent } from "../navbar/navbar.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { HomePage } from "src/app/pages/home-page/home.page";
import { AppbarComponent } from "../appbar/appbar.component";
import { UtilsService } from "src/app/Services/utils/utils.service";
import { Keyboard } from "@capacitor/keyboard";

@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ChatPageModule,
    RouterModule,
    NavbarComponent,
    SidebarComponent,
    HomePage,
    IonContent,
    AppbarComponent,
    IonHeader,
  ],
})
export class ChatComponent implements OnInit {
  route = inject(ActivatedRoute);
  platform = inject(Platform);
  utilsService = inject(UtilsService);

  chatUrlResolver = this.route.snapshot.data["url"];
  countryCodeResolver = this.route.snapshot.data["departmentId"];
  customerDetailsResolver = this.route.snapshot.data["customerId"];
  customerIdResolver = this.route.snapshot.data["eId"];
  departmentIdResolver = this.route.snapshot.data["countryCode"];
  eIdResolver = this.route.snapshot.data["customerDetails"];
  isKeyboardOpen: boolean = false;

  isLandscape = computed(() => this.utilsService.isLandscape());

  constructor() {
    if (this.platform.is("capacitor")) {
      Keyboard.addListener("keyboardWillShow", () => {
        this.isKeyboardOpen = true;
      });

      Keyboard.addListener("keyboardWillHide", () => {
        this.isKeyboardOpen = false;
      });
    }
  }

  ngOnInit() {}
}
